const UserProfile = () => import("@/components/shared/UserProfile.vue");
const myCertification = () => import("@/components/shared/certipers-candidat/MyCertifications.vue");
const CandidatProfileDocuments = () =>
  import("@/components/certipers-candidat/profile/CandidatProfileDocuments.vue");
const CandidatProfileDocumentsReceived = () =>
  import("@/components/certipers-candidat/profile/CandidatProfileDocumentsReceived.vue");

export default [
  {
    path: "UserProfile",
    name: "candidate-profile-main",
    component: UserProfile,
  },
  {
    path: "myCertifications",
    name: "candidate-myCertifications",
    component: myCertification,
  },
  {
    path: "documents",
    name: "candidate-documents",
    component: CandidatProfileDocuments,
  },
  {
    path: "documents-received",
    name: "candidate-documents-received",
    component: CandidatProfileDocumentsReceived,
  },
];
